import { useEffect, useState, useCallback } from "react";
import {
  fetchBusinessSettings,
  DEFAULT_BUSINESS_SETTINGS,
  type BusinessSettings,
} from "@/lib/businessSettings";
import { supabase } from "@/integrations/supabase/client";

export function useBusinessSettings() {
  const [settings, setSettings] = useState<BusinessSettings>(DEFAULT_BUSINESS_SETTINGS);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const s = await fetchBusinessSettings();
      setSettings(s);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const channel = (supabase as any)
      .channel("business_settings_changes")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "business_settings" },
        () => load(),
      )
      .subscribe();
    return () => {
      try {
        (supabase as any).removeChannel(channel);
      } catch {
        /* noop */
      }
    };
  }, [load]);

  return { settings, loading, reload: load };
}
